import axios from './axios'
export default {
    get: (url, payload = {}) => {
        const totalUrl = url + querify(payload)
        return axios.get(totalUrl)
    },
    post: (url, payload = {}) => {
        return axios.post(url, payload)
    },
    put: (url, payload) => {
        return axios.post(url, putMethod(payload))
    },
    delete: (url, payload) => {
        const totalUrl = url + querify(payload)
        return axios.delete(totalUrl)
        // return axios.post(totalUrl);
    },
    querify: params => querify(params),
}

const putMethod = (payload) => {
    if (isFormData(payload)) {
        payload.append('_method', 'PUT')
    } else {
        payload['_method'] = 'PUT'
    }
    return payload
}

const isObject = o => {
    return o === Object(o) && !isArray(o) && typeof o !== 'function'
}

const isArray = o => {
    return Array.isArray(o)
}

const isFormData = o => o instanceof FormData

const querify = params => {
    if (!params || !Object.keys(params).length) return ''
    const arrParams = []
    Object.keys(params).map(
        key =>
        typeof params[key] !== 'undefined' &&
        params[key] !== '' &&
        params[key] !== null &&
        arrParams.push(paramValue(key, params))
    )
    const union = !!arrParams.length ? '?' : ''
    const queryString = union + arrParams.join('&')
    return queryString
}
const paramValue = (key, data) => {
    if (Array.isArray(data[key])) {
        return `${key}=${data[key].join(',')}`
    }
    return `${key}=${data[key]}`
}
